import { useSettings } from "../context/SettingsContext";

const has = (v) => typeof v === "string" && v.trim().length > 0;

export default function Marquee() {
  const { settings } = useSettings();
  const list = Array.isArray(settings.materials) ? settings.materials.filter(has) : null;
  if (!list || list.length === 0) return null;
  const stream = [...list, ...list];
  return (
    <section
      data-testid="marquee-materials"
      aria-label="Materiali"
      className="border-y border-[color:var(--tr-border)] py-6 overflow-hidden bg-[color:var(--tr-bg)]"
    >
      <div className="flex tr-marquee-track gap-12 whitespace-nowrap will-change-transform">
        {stream.map((w, i) => (
          <span
            key={i}
            className="font-display text-3xl sm:text-4xl italic"
            style={{ color: "#1A1918" }}
          >
            {w}
            <span className="mx-12" style={{ color: "#9E8B65" }}>·</span>
          </span>
        ))}
      </div>
    </section>
  );
}
